import React, { Component } from 'react';
import SafeReactPaginate from '../../General/SafeReactPaginate';
import { connect } from 'react-redux';
import { fetchOrdenesEnVerde, setFiltroOrdenes } from '../../../actions/ordenesActions';
import { limpiarFiltros } from '../../../actions/generalActios';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import OrdenProvListItem from './OrdenProvListItem';
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import BigSpinner from "../../General/BigSpinner";
import FiltroOrdenes from '../FiltroOrdenesProveedores';
import PropTypes from "prop-types";
import '../../Publicaciones/Components/PublicacionStyles.css';
import '../OrdenesStyles.css';

const fechaFiltro = filtroMedioMes();


class ListOrdenesProv extends Component {
    constructor(props) {
        super(props);
        const idUsuarioProveedor =
            props.userType?.isProveedor && props.userId > 0 ? props.userId : "";
        this.state = {
            currentPage: 1,
            request: {
                idUsuario: idUsuarioProveedor,
                cantidadPagina: 10,
                numeroPagina: 1,
                documento: "",
                idOrden: "",
                idEstado: "",
                nombre: "",
                apellido: "",
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                fechaModific: "",
                skuMarket: "",
                idTipoPlataforma: null,
                idOrdenDesde: null,
                idOrdenHasta: null
            },
            showFilter: true,
        };
    }

    componentDidMount() {
        const userType = this.props.userType || {};
        const emptyFiltroOrdenes = Boolean(this.props.emptyFiltro?.ordenes);

        let estadoInicioFiltraPor_Moderador = {
            ...this.state.request,
            idUsuario: ""
        };

        let request = this.props.filtro;

        if (emptyFiltroOrdenes) {
            if (userType.isAdminMod || userType.isSoloLectura) {
                this.props.setFiltroOrdenes(estadoInicioFiltraPor_Moderador);
                this.setState({ request: estadoInicioFiltraPor_Moderador })
                this.props.fetchOrdenesEnVerde(estadoInicioFiltraPor_Moderador);
            } else {
                const reqInicial = userType.isProveedor
                    ? {
                        ...this.state.request,
                        codProv: this.props.codProv,
                        idUsuario: this.props.userId > 0 ? this.props.userId : this.state.request.idUsuario
                    }
                    : this.state.request;
                this.props.setFiltroOrdenes(reqInicial);
                this.setState(prevState => ({ request: userType.isProveedor ? { ...prevState.request, codProv: this.props.codProv, idUsuario: this.props.userId > 0 ? this.props.userId : this.state.request.idUsuario } : prevState.request}));
                this.props.fetchOrdenesEnVerde(reqInicial);
            }
        } else {
            request.numeroPagina = 1;
            const reqConProveedor = userType.isProveedor
                ? {
                    ...request,
                    codProv: this.props.codProv,
                    idUsuario: this.props.userId > 0 ? this.props.userId : request.idUsuario
                }
                : request;
            this.props.setFiltroOrdenes(reqConProveedor);
            this.setState({ request: reqConProveedor });
            this.props.fetchOrdenesEnVerde(reqConProveedor);
        }

        if (userType.isAdminMod || userType.isSoloLectura) {
            this.props.fetchSellersFilter(null);
        }
    }

    handleShowFilter = (value) => {
        this.setState({ showFilter: value });
        this.props.setFiltroOrdenes({ ...this.props.filtro, showFilter: value });
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        let params = {};

        const { userType } = this.props;
        if (userType.isAdminMod || userType.isSoloLectura) {
            params = {
                ...this.state.request,
                numeroPagina: selectedPage
            }
        } else {
            params = {
                ...this.state.request,
                idUsuario: userType.isProveedor && this.props.userId > 0 ? this.props.userId : "",
                numeroPagina: selectedPage
            }
        }

        this.setState({
            request: params
        });

        this.updateRequest(params);
    };

    updateRequest = (request) => {
        let merged = { ...this.state.request, ...request };
        const { userType } = this.props;
        if (!userType.isAdminMod && !userType.isSoloLectura) {
            merged.idUsuario = userType.isProveedor && this.props.userId > 0 ? this.props.userId : "";
            if (userType.isProveedor) {
                merged.codProv = this.props.codProv;
            }
        }

        const params = {
            ...this.state,
            request: merged
        };

        this.setState({ request: params.request, currentPage: params.request.numeroPagina }, () => {
            this.props.setFiltroOrdenes(this.state.request);
            this.props.fetchOrdenesEnVerde(this.state.request);
        });
    }


    render() {
        const ordenes = this.props.ordenes || {};
        const userType = this.props.userType || {};
        const elementos = Array.isArray(ordenes.elementos) ? ordenes.elementos : [];
        const cantidadTotal = Number(this.props.ordenes?.cantidadTotal) || 0;
        const cantidadPaginaSegura = Math.max(1, Number(this.state.request?.cantidadPagina) || 1);
        const pageCount = Math.ceil(cantidadTotal / cantidadPaginaSegura);

        return (
            <div className="container py-2 pub-catalog">
                <header className="pub-catalog__mast">
                    <div className="pub-catalog__intro">
                        <p className="pub-catalog__kicker">Gestión</p>
                        <h4 className="pub-catalog__title">Órdenes de proveedores</h4>
                        <p className="pub-catalog__subtitle">Seguimiento de ventas, obleas y comprobantes.</p>
                    </div>
                </header>

                <div hidden={!this.state.showFilter}>
                    <FiltroOrdenes
                        filtro={this.props.filtro}
                        updateRequest={this.updateRequest}
                        tipoUsuario={userType}
                        allowSearchBySeller={false}
                        onMinimize={() => this.handleShowFilter(false)}
                    />
                </div>

                {!this.state.showFilter && (
                    <button
                        type="button"
                        className="pub-catalog__filter-open"
                        onClick={() => this.handleShowFilter(true)}
                        aria-expanded={false}
                    >
                        <span className="pub-catalog__filter-open-icon" aria-hidden="true">
                            <i className="fa fa-filter" />
                        </span>
                        <span className="pub-catalog__filter-open-copy">
                            <strong>Abrir filtros</strong>
                            <small>Orden, proveedor, cliente y período</small>
                        </span>
                        <i className="fa fa-chevron-down pub-catalog__filter-open-chevron" aria-hidden="true" />
                    </button>
                )}

                {this.props.loadingOrdenes ? <BigSpinner message="Cargando ordenes de proveedores..." /> :
                    <div>
                        {elementos.length > 0 ?
                            <div className="list-group pub-catalog__list">
                                {elementos.map((orden) => {
                                    if (!userType?.isAdminMod) {
                                        return (
                                            <OrdenProvListItem
                                                key={orden.idOrden}
                                                mailCliente={""}
                                                idOrden={orden.idOrden}
                                                fecha={orden.fecha}
                                                cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                                montoVenta={orden.montoVenta}
                                                productos={orden.productos}
                                                obleaDescargada={orden.obleaDescargada}
                                                comprobante={orden.comprobante}
                                                userId={this.props.userId}
                                            />
                                        )
                                    }
                                    else if (userType?.isAdminMod || userType?.isSoloLectura) {
                                        return (
                                            <OrdenProvListItem
                                                key={orden.idOrden}
                                                mailCliente={orden.cliente.email}
                                                idOrden={orden.idOrden}
                                                fecha={orden.fecha}
                                                cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                                montoVenta={orden.montoVenta}
                                                productos={orden.productos}
                                                dniIdBocaSeller={orden.idVendedorBoca}
                                                plataformaCodigo={orden.plataforma.codigo}
                                                obleaDescargada={orden.obleaDescargada}
                                                comprobante={orden.comprobante}
                                                userId={this.props.userId}
                                            />
                                        )
                                    }
                                    return null;
                                })}
                            </div>
                            :
                            <div className="pub-catalog__empty">
                                <i className="ti-package" aria-hidden="true" />
                                <p>No se encontraron resultados</p>
                            </div>
                        }
                    </div>
                }

                <div className="d-flex justify-content-center">
                    <SafeReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={5}
                        pageRangeDisplayed={this.state.request.cantidadPagina}
                        onPageChange={this.handlePageClick}

                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={
                            this.props.filtro?.numeroPagina ?
                                this.props.filtro.numeroPagina - 1 : 0
                        }
                    />
                </div>
            </div>
        );
    }
}
ListOrdenesProv.propTypes = {
    // Redux props
    filtro: PropTypes.shape({
        showFilter: PropTypes.bool,
        numeroPagina: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    userType: PropTypes.shape({
        isSoloLectura: PropTypes.bool,
        isAdminMod: PropTypes.bool,
        isProveedor: PropTypes.bool,
    }),
    emptyFiltro: PropTypes.shape({
        ordenes: PropTypes.bool,
    }),
    codProv: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ordenes: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        elementos: PropTypes.array,
        cantidadTotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })]),
    loadingOrdenes: PropTypes.bool,
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // Actions props
    setFiltroOrdenes: PropTypes.func,
    fetchOrdenesEnVerde: PropTypes.func,
    fetchSellersFilter: PropTypes.func,
}

const mapStateToProps = state => ({
    idSeller: state.general.idSeller,
    userType: state.general.userType || {},
    loadingOrdenes: state.ordenes.loadingOrdenes,
    emptyFiltro: state.general.limpiar || {},
    ordenes: state.ordenes.ordenesEnVerde,
    filtro: state.ordenes.filtro,
    userId: state.general.userId,
    codProv: state.general.codProv
});

export default connect(mapStateToProps, {
    fetchOrdenesEnVerde,
    limpiarFiltros,
    setFiltroOrdenes,
    fetchSellersFilter
})(ListOrdenesProv);